'use strict';

var React = require('react');

var SvgWeightMinor = function SvgWeightMinor(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M12.83 6a3 3 0 1 0-5.66 0h-1.012a2.19 2.19 0 0 0-2.095 1.568l-1.97 6.6c-.419 1.411.631 2.832 2.097 2.832h11.622c1.465 0 2.516-1.42 2.095-2.832l-1.969-6.6a2.19 2.19 0 0 0-2.096-1.568h-1.013Zm-2.83 0a1 1 0 1 0 0-2 1 1 0 0 0 0 2Z"
  }));
};

exports.SvgWeightMinor = SvgWeightMinor;
